export const PAGE_TITLE = 'Store Details Update';
